export const FBA_SHIPMENT_ID_LENGTH = 12;
export const FBA_REFERENCE_ID_LENGTH = 8;
export const AMAZON_UPSTREAM_STORAGE_SHIPMENT_ID_LENGTH = 18;
export const FREIGHT_PICKUP_DAYS_LIMIT = 14;
